// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"2638":"StoryblokComponents","5564":"ListingPage"}[chunkId] || chunkId) + "." + {"2638":"ef869507","5564":"ef869507","8626":"1c1b31a5"}[chunkId] + ".chunk.css";
};